export const BASE_URL = "https://www.xmusic.hu/";
export const ART_WORK_URL = "NowOnAir.xml";
export const DEFAULT_ARTWORK = `default.png`;
